import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 10, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 6.00015L4 10.0044L12 2.00015L10.5858 0.585938L4 7.17515L1.41421 4.58594L0 6.00015Z", fill: "#2D3748" }));
export default SvgCheck;
